import { combineSlices } from "@reduxjs/toolkit";
import documentUploadsSlice from "slices/documentUploads/documentUploadsSlice";
import { dueDateTimeline, opportunityTimeline } from "slices/timeline";

import agenciesSlice from "./agencies/agenciesSlice";
import customerSlice from "./customers/customerSlice";
import opportunitiesSlice from "./opportunities/opportunitiesSlice";
import samGovIngestStatusSlice from "./samGovIngestStatus/samGovIngestStatusSlice";
import setAsidesSlice from "./setAsides/setAsidesSlice";
import summarySlice from "./summary/summarySlice";
import trackedSlice from "./tracked/trackedSlice";

const combined = combineSlices(
  summarySlice,
  opportunitiesSlice,
  documentUploadsSlice,
  trackedSlice,
  agenciesSlice,
  setAsidesSlice,
  customerSlice,
  samGovIngestStatusSlice,
  opportunityTimeline.slice,
  dueDateTimeline.slice
);
export default combined;
